import { useQuery, useMutation, } from "@tanstack/react-query";
export const createScoresheetCommentsQueries = (requests, queryClient) => ({
    useListScoresheetComments: (params, options = {}) => useQuery({
        queryKey: ["scoresheet-comments", params],
        queryFn: async ({ queryKey }) => {
            const [_key, params] = queryKey;
            return requests.listScoresheetComments(params);
        },
        ...options,
    }),
    useCreateScoresheetComment: (options = {}) => useMutation({
        ...options,
        mutationFn: (attrs) => {
            return requests.createScoresheetComment(attrs);
        },
        onSuccess: () => {
            queryClient.invalidateQueries({ queryKey: ["scoresheet-comments"] });
            options.onSuccess?.(null, null, null);
        },
    }),
});
//# sourceMappingURL=index.js.map